import React from 'react';

import { TitleBadge } from '@src/components/atoms/title-badge';
import { Heading11, Heading7, Paragraph3 } from '@src/theme';
import { bemClassName } from '@src/utils/bem';

import { services } from './ServicesData';
import { StyledAboutOurServicesSection } from './styles';

const b = bemClassName('about-our-services-section');

const AboutOurServicesSection = () => {
  return (
    <StyledAboutOurServicesSection>
      <div className={b()}>
        <div className={b('inner')}>
          <div className={b('heading')}>
            <TitleBadge text="OUR SERVICES" />
            <Heading7>What We Offer</Heading7>
            <div className={b('heading-desc')}>
              <Paragraph3>
                Everything you need to transform your health — powered by AI, backed by science, built for real life.
              </Paragraph3>
            </div>
          </div>
          <div className={b('grid')}>
            {services.map((service, index) => (
              <div key={index} className={b('card')}>
                <div className={b('card-icon')}>{service.icon}</div>
                <div className={b('card-content')}>
                  <Heading11>{service.title}</Heading11>
                  <div className={b('card-desc')}>
                    <Paragraph3>{service.paragraph}</Paragraph3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </StyledAboutOurServicesSection>
  );
};

export default AboutOurServicesSection;
